import React, { useState, useEffect } from 'react'
import Likert from 'react-likert-scale'
import _ from "lodash";
import './FeedbackForm.scss';

export interface IQuestion {
    id: string,
    question: string,
    responses: IResponse[],
    selected?: IResponse
}
export interface IResponse {
    value: number,
    text: string
}

export interface IFeedbackFormProps {
    onSubmit: ( any ),
    questions?: IQuestion[]
}

enum FormState {
    READY=1,
    COMPLETED=2,
    SUBMITTING=3
}

const defaultQuestions:IQuestion[] = [
    {
        id: "course-feedback-easy",
        question: "The course was easy to use",
        responses: [
            { value: 1, text: "Strongly Disagree" },
            { value: 2, text: "Disagree" },
            { value: 3, text: "Neither" },
            { value: 4, text: "Somewhat Agree" },
            { value: 5, text: "Strongly Agree" }
        ]
    },
    {
        id: "course-feedback-understand",
        question: "The course language was easy to understand",
        responses: [
            { value: 1, text: "Strongly Disagree" },
            { value: 2, text: "Disagree" },
            { value: 3, text: "Neither" },
            { value: 4, text: "Somewhat Agree" },
            { value: 5, text: "Strongly Agree" }
        ]
    },
    {
        id: "course-feedback-prepared",
        question: "After completing the course, I feel prepared",
        responses: [
            { value: 1, text: "Strongly Disagree" },
            { value: 2, text: "Disagree" },
            { value: 3, text: "Neither" },
            { value: 4, text: "Somewhat Agree" },
            { value: 5, text: "Strongly Agree" }
        ]
    }
];

export const FeedbackForm = (props:IFeedbackFormProps) => {

    const [formState, setFormComplete] = useState( FormState.READY );
    const [questions, setQuestions] = useState( props.questions || defaultQuestions );

    useEffect(() => {
        let completed = 0;
        _.each(questions, (question:IQuestion) => {
            if ( question.selected ) {
                completed++;
            }
        });
        setFormComplete( completed === questions.length ? FormState.COMPLETED : FormState.READY );
    }, [questions])
    
    const onChangeHandler = (question:IQuestion, val:Number) => {
        if (question && val) {
            let questionToUpdate:any = _.find( questions, ["id", question.id]);
            questionToUpdate.selected = val;
            console.log(question, val);
            setQuestions( [...questions] );
        }        
    };

    const onSubmitHandler = () => {
        var success = false;
        if ( props.onSubmit ) {
            success = props.onSubmit( questions );
        };
        if ( success ) {
            /* reset form */
            _.each(questions, (question:IQuestion) => {
                question.selected = undefined;
            });
            setQuestions( [...questions] );
        }
    };

    const likertConfig = {
         layout: "stacked"
    };
    
    return (
        <div className="feedback-form">
        {questions.map((question:any, i:number) => 
            <Likert key={i} {...{...question, ...likertConfig}} onChange={(val:any) => { onChangeHandler( question, val ) }} />
        )}
            <button className="btn btn-lg btn-primary" disabled={formState !== FormState.COMPLETED} onClick={onSubmitHandler} onKeyPress={onSubmitHandler}>Submit</button>
        </div>
    );
}

export default FeedbackForm;
